/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerVertical } from './';
import {
    FreelancerVerticalFromJSON,
    FreelancerVerticalFromJSONTyped,
    FreelancerVerticalToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateWorkflowContextRequest
 */
export interface UpdateWorkflowContextRequest {
    /**
     * 
     * @type {FreelancerVertical}
     * @memberof UpdateWorkflowContextRequest
     */
    newVertical: FreelancerVertical;
}

/**
 * Check if a given object implements the UpdateWorkflowContextRequest interface.
 */
export function instanceOfUpdateWorkflowContextRequest(value: object): value is UpdateWorkflowContextRequest {
    if (!('newVertical' in value) || value['newVertical'] === undefined) return false;
    return true;
}

export function UpdateWorkflowContextRequestFromJSON(json: any): UpdateWorkflowContextRequest {
    return UpdateWorkflowContextRequestFromJSONTyped(json, false);
}

export function UpdateWorkflowContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWorkflowContextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newVertical': FreelancerVerticalFromJSON(json['newVertical']),
    };
}

export function UpdateWorkflowContextRequestToJSON(value?: UpdateWorkflowContextRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newVertical': FreelancerVerticalToJSON(value['newVertical']),
    };
}

